var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckboxChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 11.9965V19H5V5H18.0085L19.8291 3.1794C19.5765 3.06419 19.2957 3 19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V9.99654L19 11.9965Z",
    fill: "#C2CFE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8479 5.56384L12.2479 16.1638C12.154 16.2585 12.0262 16.3117 11.8929 16.3117C11.7596 16.3117 11.6318 16.2585 11.5379 16.1638L6.1479 10.7738C6.05324 10.68 6 10.5522 6 10.4188C6 10.2855 6.05324 10.1577 6.1479 10.0638L6.8479 9.36384C6.94178 9.26918 7.06958 9.21594 7.2029 9.21594C7.33622 9.21594 7.46402 9.26918 7.5579 9.36384L11.8879 13.6938L21.4379 4.14384C21.6357 3.95205 21.9501 3.95205 22.1479 4.14384L22.8479 4.85384C22.9426 4.94772 22.9958 5.07552 22.9958 5.20884C22.9958 5.34216 22.9426 5.46995 22.8479 5.56384Z",
    fill: "#4494FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckboxChecked);
export default __webpack_public_path__ + "static/media/icon-checkbox-checked.8cc7fc2e.svg";
export { ForwardRef as ReactComponent };